const isObject = (obj: any): obj is object => obj !== null && typeof obj === 'object' && !Array.isArray(obj);

export default function deepMerge<T, U>(target: T, source: U): T & U {
    if (Array.isArray(target) && Array.isArray(source)) {
        const maxLength = Math.max(target.length, source.length);
        const result = [];

        for (let i = 0; i < maxLength; i++) {
            if (i in source) {
                if (isObject(target[i]) && isObject(source[i])) {
                    result[i] = deepMerge(target[i], source[i]);
                } else {
                    result[i] = source[i];
                }
            } else {
                result[i] = target[i];
            }
        }

        return result as T & U;
    }

    if (isObject(target) && isObject(source)) {
        const result: any = { ...target };

        for (const key in source) {
            if (isObject(source[key]) && isObject(result[key])) {
                result[key] = deepMerge(result[key], source[key]);
            } else if (Array.isArray(source[key]) && Array.isArray(result[key])) {
                result[key] = deepMerge(result[key], source[key]);
            } else {
                result[key] = source[key];
            }
        }

        return result as T & U;
    }

    return source as T & U;
}
